import type { CompanyPhysicalAddress } from 'src/components/pages/info/document/index/types'

type AddressVariant = 'legal' | 'actual' | 'short'

/**
 * Форматирует адрес компании из context так же, как django-шаблон company_address.html.
 */
export default function formatCompanyAddress(
  address: CompanyPhysicalAddress | undefined,
  variant: AddressVariant,
): string {
  if (!address) {
    return ''
  }

  if (variant === 'short') {
    return `г. ${address.city}, ул. ${address.street}, д. ${address.building}, ${address.floors} этажи`
  }

  if (variant === 'actual') {
    return `${address.postal_code}, ${address.region}, г. ${address.city}, ул. ${address.street}, д. ${address.building}, ${address.floors} этажи`
  }

  return `${address.postal_code}, ${address.region}, г. ${address.city}, ул. ${address.street}, д. ${address.building}, офис ${address.office}`
}
